import { inferRouteObject } from 'react-router-typed-object';
import { z } from 'zod';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, and, not, or } from '@/js/libs/use-auth';

import CRM, { ContactFormSearchParams } from 'src/scenes/CRM';
import { AccountsListSearchParams } from 'src/scenes/CRM/containers/Accounts/containers/AccountsList/types';
import { ContactsListSearchParams } from 'src/scenes/CRM/containers/Contacts/types';
import Status from 'src/scenes/Status';

const index = true;

export const crmRouteObject = inferRouteObject({
  path: 'crm',
  element: (
    <PrivateRoute
      roles={and(or(Roles.MANAGE_ACCOUNTS, Roles.SELF_BOOKING), not(or(Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER)))}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: CRM.Helmet,
      children: [
        { path: 'discounts', Component: CRM.Discounts },
        {
          element: <CRM.FeatureToggleContextProvider />,
          children: [
            {
              path: 'accounts',
              searchParams: AccountsListSearchParams.parse,
              children: [
                { index, Component: CRM.Accounts.AccountsList },
                { path: 'create', Component: CRM.Accounts.AccountForm },
                {
                  path: ':accountId',
                  children: [
                    { index, Component: CRM.Accounts.AccountOverview },
                    {
                      path: 'conversion-tracker',
                      children: [
                        { path: 'create', Component: CRM.Accounts.ConversionTrackerForm },
                        { path: 'edit/:conversionTrackerId', Component: CRM.Accounts.ConversionTrackerForm },
                      ],
                    },
                  ],
                },
                {
                  path: 'edit',
                  children: [
                    { index, element: <Navigate to='../' replace /> },
                    { path: ':accountId', Component: CRM.Accounts.AccountForm },
                  ],
                },
              ],
            },
            {
              element: <PrivateRoute roles={Roles.MANAGE_ACCOUNTS} noAccessComponent={Status.NotFound} />,
              children: [
                {
                  path: 'contacts',
                  searchParams: ContactsListSearchParams.parse,
                  children: [
                    { index, Component: CRM.Contacts },
                    {
                      path: 'create',
                      Component: CRM.ContactForm,
                      searchParams: z.object({
                        [ContactFormSearchParams.ACCOUNT_ID]: z.string().optional(),
                        [ContactFormSearchParams.REDIRECT_TO]: z.string().optional(),
                      }).parse,
                    },
                    {
                      path: 'edit',
                      children: [
                        { index, element: <Navigate to='../' replace /> },
                        {
                          path: ':contactId',
                          Component: CRM.ContactForm,
                          searchParams: z.object({
                            [ContactFormSearchParams.ACCOUNT_ID]: z.string().optional(),
                            [ContactFormSearchParams.REDIRECT_TO]: z.string().optional(),
                          }).parse,
                        },
                      ],
                    },
                    {
                      path: 'history',
                      children: [
                        { index, element: <Navigate to='contacts' replace /> },
                        { path: ':contactId', Component: CRM.ContactHistory },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
